import { CapitalDepositStatus } from '__generated__/GQL';

export const APPLICATION_FOLLOW_UP_STEPS = {
  [CapitalDepositStatus.FormInvalid]: null,
  [CapitalDepositStatus.OptedOut]: null,
  [CapitalDepositStatus.ProviderApplicationCreated]: null,
  [CapitalDepositStatus.Refused]: null,

  [CapitalDepositStatus.Initiated]: 'verification',
  [CapitalDepositStatus.FormCompleted]: 'verification',
  [CapitalDepositStatus.ApplicationSubmitted]: 'verification',
  [CapitalDepositStatus.KycSentForPrecheck]: 'verification',
  [CapitalDepositStatus.KycPrechecked]: 'verification',
  [CapitalDepositStatus.KycSentToTreezor]: 'verification',
  [CapitalDepositStatus.KycSentForPostcheck]: 'verification',
  [CapitalDepositStatus.KycValidated]: 'verification',
  [CapitalDepositStatus.KycInvalid]: 'verification',

  [CapitalDepositStatus.FundsReceived]: 'registration',
  [CapitalDepositStatus.CertificateOfDepositSent]: 'registration',

  [CapitalDepositStatus.IbanstartAccountCreated]: 'funds',
  [CapitalDepositStatus.ProviderAccountCreated]: 'funds',

  [CapitalDepositStatus.CompanyCreated]: 'account-opening',
  [CapitalDepositStatus.KybSentForPrecheck]: 'account-opening',
  [CapitalDepositStatus.KybPrechecked]: 'account-opening',
  [CapitalDepositStatus.KybSentToTreezor]: 'account-opening',
  [CapitalDepositStatus.KybInvalid]: 'account-opening',
  [CapitalDepositStatus.KybValidated]: 'account-opening',
  [CapitalDepositStatus.KybSentForPostcheck]: 'account-opening',
  [CapitalDepositStatus.FundsReleaseInitiated]: 'account-opening',
  [CapitalDepositStatus.FundsReleased]: 'account-opening',
} satisfies Record<
  CapitalDepositStatus,
  'account-opening' | 'funds' | 'registration' | 'verification' | null
>;
